import { Object3D } from 'three';
import {
  deregisterObject,
  intersections,
  registerObject,
} from './raycaster';

// returns true if it wants the click event to propagate
type HoverCallback = (event: MouseEvent) => boolean | void;

interface HoverCallbacks {
  on: HoverCallback;
  off: HoverCallback;
}

const hoverCallbacks: Record<string, HoverCallbacks> = {};
const currentlyHoveredObjects: Record<string, number> = {};

document.addEventListener('mousemove', onMouseMove);
function onMouseMove(event: MouseEvent) {
  // event.preventDefault();

  const now = Date.now();
  for (const intersection of intersections) {
    const { uuid } = intersection.object;

    const callbacks = hoverCallbacks[uuid];
    if (callbacks) {
      const propagateEvent = callbacks.on(event);
      currentlyHoveredObjects[uuid] = now;
      if (!propagateEvent) return;
    }
  }

  Object.keys(currentlyHoveredObjects).forEach((uuid) => {
    const timestamp = currentlyHoveredObjects[uuid];
    if (timestamp < now) {
      const callbacks = hoverCallbacks[uuid];
      if (callbacks) callbacks.off(event);
      delete currentlyHoveredObjects[uuid];
    }
  });
}

export function registerOnHover(obj: Object3D, onCallback: HoverCallback, offCallback: HoverCallback) {
  if (!hoverCallbacks[obj.uuid]) {
    registerObject(obj);
    hoverCallbacks[obj.uuid] = {
      on: onCallback,
      off: offCallback,
    };
  }
}

// note: not tested yet
export function deregisterOnHover(obj: Object3D) {
  delete hoverCallbacks[obj.uuid]
  deregisterObject(obj);
}
